module.exports = __webpack_public_path__ + "static/media/play-boss-shooting.864a2966.png";